"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracker = void 0;
var lodash_1 = __importDefault(require("lodash"));
var Tracker = (function () {
    function Tracker(make, googleAnalyticsIntegrationEnabled, mixPanelIntegrationEnabled, heapAnalyticsIntegrationEnabled) {
        this.trackAcceptClick = this.trackAcceptClick.bind(this);
        this.trackAccept = this.trackAccept.bind(this);
        this.trackProjectOpen = this.trackProjectOpen.bind(this);
        this.trackLinkClick = this.trackLinkClick.bind(this);
        this.trackBlockView = this.trackBlockView.bind(this);
        this.trackHeartbeat = this.trackHeartbeat.bind(this);
        this.trackers = [];
        if (googleAnalyticsIntegrationEnabled) {
            var googleAnalyticsTracker = make(require("./Trackers/GoogleAnalyticsTracker"));
            this.trackers.push(googleAnalyticsTracker);
        }
        if (mixPanelIntegrationEnabled) {
            var mixPanelTracker = make(require("./Trackers/MixPanelTracker"));
            this.trackers.push(mixPanelTracker);
        }
        if (heapAnalyticsIntegrationEnabled) {
            var heapAnalyticsTracker = make(require("./Trackers/HeapAnalyticsTracker"));
            this.trackers.push(heapAnalyticsTracker);
        }
    }
    Tracker.prototype.trackAcceptClick = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return lodash_1.default.each(this.trackers, function (tracker) { return tracker.trackAcceptClick.apply(tracker, __spreadArray([], __read(args), false)); });
    };
    Tracker.prototype.trackAccept = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return lodash_1.default.each(this.trackers, function (tracker) { return tracker.trackAccept.apply(tracker, __spreadArray([], __read(args), false)); });
    };
    Tracker.prototype.trackProjectOpen = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return lodash_1.default.each(this.trackers, function (tracker) { return tracker.trackProjectOpen.apply(tracker, __spreadArray([], __read(args), false)); });
    };
    Tracker.prototype.trackLinkClick = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return lodash_1.default.each(this.trackers, function (tracker) { return tracker.trackLinkClick.apply(tracker, __spreadArray([], __read(args), false)); });
    };
    Tracker.prototype.trackBlockView = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return lodash_1.default.each(this.trackers, function (tracker) { return tracker.trackBlockView.apply(tracker, __spreadArray([], __read(args), false)); });
    };
    Tracker.prototype.trackHeartbeat = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return lodash_1.default.each(this.trackers, function (tracker) { return tracker.trackHeartbeat.apply(tracker, __spreadArray([], __read(args), false)); });
    };
    return Tracker;
}());
exports.Tracker = Tracker;
